import React, {Component} from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import FormError from "../../components/forms/FormError";
import FieldError from "../../components/forms/FieldError";
import "./CartSubscriptionForm.css";
import "../../components/InlineTable.css";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return 0;
  if (parsed < 0) return 0;
  return parsed;
}

class CartSubscriptionForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form className="CartSubscriptionForm" onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Subscription Name"
              name="name"
              component={TextInputField}
              />            
            <Field
              label="Frequency Weeks"
              name="frequencyWeeks"
              type="number"
              component={TextInputField}
              normalize={numerical}
              />            
          </FormFieldsTable>
          <FieldArray name="products" props={{serverError: errors.products}} component={this.renderMembers} />
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
          <ActionButton label="Remove Subscription" show={this.props.showRemove} onClick={this.props.onRemove} />
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
        </div>
      </form>
    )
  }

  renderMembers({fields, meta: {error, submitFailed, dirty}, serverError}) {
    let products = fields.map((member, index) => {
      let product = fields.get(index);
      return (
        <tr key={index}>
          <td>
            {product.get("productTitle")}<br/>
            <span className="sku">{product.get("productSku")}</span>
          </td>
          <td className="u-no-wrap field-quantity">
            <Field
              label="Qty."
              name={`${member}.quantity`}
              type="number"
              component={TextInputField}
              normalize={numerical}
              table={false}
              />
          </td>
        </tr>
      );
    });

    return (
      <div className="products">
        <div className="InlineTable">
          <table>
            <thead>
              <tr>
                <td>Product</td>
                <td>Qty.</td>  
              </tr>
            </thead>
            <tbody>
              {products}
            </tbody>
          </table>
        </div>
        <FieldError serverError={serverError} clientError={error} showClientError={dirty && error} />
      </div>
    )
  }
}

CartSubscriptionForm.defaultProps = {
  showRemove: false
}

const ReduxForm = reduxForm({
  form: "CartSubscriptionForm"
})(CartSubscriptionForm);

export default ReduxForm;